"use strict";

var _objectSpread = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var Menu_1 = require("./Menu");
var hooks_1 = require("material-ui-popup-state/hooks");
var HoverMenu_1 = __importDefault(require("material-ui-popup-state/HoverMenu"));
var ChevronRight_1 = __importDefault(require("@mui/icons-material/ChevronRight"));
var CascadingContext = react_1.default.createContext({
  parentPopupState: null,
  rootPopupState: null
});
function CascadingMenuItem(_ref) {
  var onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, ["onClick"]);
  var _ref2 = (0, react_1.useContext)(CascadingContext),
    rootPopupState = _ref2.rootPopupState;
  if (!rootPopupState) {
    throw new Error('must be used inside a CascadingMenu');
  }
  var handleClick = (0, react_1.useCallback)(function (event) {
    rootPopupState.close();
    onClick === null || onClick === void 0 ? void 0 : onClick(event);
  }, [rootPopupState, onClick]);
  return react_1.default.createElement(material_1.MenuItem, _objectSpread({}, props, {
    onClick: handleClick
  }));
}
function CascadingSubmenu(_ref3) {
  var title = _ref3.title,
    inset = _ref3.inset,
    popupId = _ref3.popupId,
    props = _objectWithoutProperties(_ref3, ["title", "inset", "popupId"]);
  var _react_1$default$useC = react_1.default.useContext(CascadingContext),
    parentPopupState = _react_1$default$useC.parentPopupState;
  var popupState = (0, hooks_1.usePopupState)({
    popupId: popupId,
    variant: 'popover',
    parentPopupState: parentPopupState
  });
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(material_1.MenuItem, _objectSpread({}, (0, hooks_1.bindHover)(popupState), (0, hooks_1.bindFocus)(popupState)), react_1.default.createElement(material_1.ListItemText, {
    primary: title,
    inset: inset
  }), react_1.default.createElement(ChevronRight_1.default, null)), react_1.default.createElement(CascadingSubmenuHover, _objectSpread({}, props, {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    popupState: popupState
  })));
}
function CascadingSubmenuHover(_ref4) {
  var popupState = _ref4.popupState,
    onMenuItemClick = _ref4.onMenuItemClick,
    menuItems = _ref4.menuItems,
    classes = _ref4.classes,
    props = _objectWithoutProperties(_ref4, ["popupState", "onMenuItemClick", "menuItems", "classes"]);
  var _ref5 = (0, react_1.useContext)(CascadingContext),
    rootPopupState = _ref5.rootPopupState;
  var context = (0, react_1.useMemo)(function () {
    return {
      rootPopupState: rootPopupState || popupState,
      parentPopupState: popupState
    };
  }, [rootPopupState, popupState]);
  return react_1.default.createElement(CascadingContext.Provider, {
    value: context
  }, react_1.default.createElement(HoverMenu_1.default, _objectSpread({}, props, (0, hooks_1.bindMenu)(popupState))));
}
function CascadingMenu(_ref6) {
  var popupState = _ref6.popupState,
    onMenuItemClick = _ref6.onMenuItemClick,
    menuItems = _ref6.menuItems,
    props = _objectWithoutProperties(_ref6, ["popupState", "onMenuItemClick", "menuItems"]);
  var _react_1$default$useC2 = react_1.default.useContext(CascadingContext),
    rootPopupState = _react_1$default$useC2.rootPopupState;
  var context = react_1.default.useMemo(function () {
    return {
      rootPopupState: rootPopupState || popupState,
      parentPopupState: popupState
    };
  }, [rootPopupState, popupState]);
  return react_1.default.createElement(CascadingContext.Provider, {
    value: context
  }, react_1.default.createElement(material_1.Menu, _objectSpread({}, props, (0, hooks_1.bindMenu)(popupState))));
}
function EndDecoration(_ref7) {
  var item = _ref7.item;
  if ('subMenu' in item) {
    return react_1.default.createElement(Menu_1.MenuItemEndDecoration, {
      type: "subMenu"
    });
  } else if (item.type === 'checkbox' || item.type === 'radio') {
    return react_1.default.createElement(Menu_1.MenuItemEndDecoration, {
      type: item.type,
      checked: item.checked,
      disabled: item.disabled
    });
  }
  return null;
}
function CascadingMenuList(_ref8) {
  var onMenuItemClick = _ref8.onMenuItemClick,
    menuItems = _ref8.menuItems,
    props = _objectWithoutProperties(_ref8, ["onMenuItemClick", "menuItems"]);
  function handleClick(callback) {
    return function (event) {
      onMenuItemClick(event, callback);
    };
  }
  var hasIcon = menuItems.some(function (menuItem) {
    return 'icon' in menuItem && menuItem.icon;
  });
  return react_1.default.createElement(react_1.default.Fragment, null, menuItems.map(function (item, idx) {
    return 'subMenu' in item ? react_1.default.createElement(CascadingSubmenu, {
      key: "subMenu-".concat(item.label, "-").concat(idx),
      popupId: "subMenu-".concat(item.label),
      title: item.label,
      inset: hasIcon,
      onMenuItemClick: onMenuItemClick,
      menuItems: item.subMenu
    }, react_1.default.createElement(CascadingMenuList, _objectSpread({}, props, {
      onMenuItemClick: onMenuItemClick,
      menuItems: item.subMenu
    }))) : item.type === 'divider' ? react_1.default.createElement(material_1.Divider, {
      key: "divider-".concat(idx),
      component: "li"
    }) : item.type === 'subHeader' ? react_1.default.createElement(material_1.ListSubheader, {
      key: "subHeader-".concat(item.label, "-").concat(idx)
    }, item.label) : react_1.default.createElement(CascadingMenuItem, {
      key: "".concat(item.label, "-").concat(idx),
      onClick: 'onClick' in item ? handleClick(item.onClick) : undefined,
      disabled: Boolean(item.disabled)
    }, item.icon ? react_1.default.createElement(material_1.ListItemIcon, null, react_1.default.createElement(item.icon, null)) : null, ' ', react_1.default.createElement(material_1.ListItemText, {
      primary: item.label,
      secondary: item.subLabel,
      inset: hasIcon && !item.icon
    }), react_1.default.createElement("div", {
      style: {
        flexGrow: 1,
        minWidth: 10
      }
    }), react_1.default.createElement(EndDecoration, {
      item: item
    }));
  }));
}
function CascadingMenuChildren(props) {
  return react_1.default.createElement(CascadingMenu, _objectSpread({}, props), react_1.default.createElement(CascadingMenuList, _objectSpread({}, props)));
}
exports.default = CascadingMenuChildren;